import { useEffect, useRef } from 'react';
import { type FieldValues, type Path, type UseFormSetValue } from 'react-hook-form';

type useSetGeolocatedCountryArgs<TFieldValues extends FieldValues> = {
  field: Path<TFieldValues>;
  setValue: UseFormSetValue<TFieldValues>;
  countryList: ReadonlyArray<Readonly<{ label: string; value: string; code: string }>>;
};

const useSetGeolocatedCountry = <TFieldValues extends FieldValues>({
  field,
  setValue,
  countryList,
}: useSetGeolocatedCountryArgs<TFieldValues>) => {
  const mountedRef = useRef(false);
  useEffect(() => {
    if (mountedRef.current) {
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    mountedRef.current = true;

    /**
     * The `html` tag contains a `data-geo-country-code` attribute prefilled
     * By the `geolocation.ts` edge function.
     */
    const documentCountry = document.querySelector('html')?.dataset.geoCountryCode;

    if (!documentCountry) {
      return;
    }

    const country = countryList.find((country) => country.code === documentCountry);

    if (country) {
      setValue(field, country as any);
    }
  }, [countryList, field, setValue]);
};

export default useSetGeolocatedCountry;
